const Config = {
  BaseURL: 'https://api.cloudcabinet.jp/',
  tokenErrorMsg: '一定時間操作されなかったため、タイムアウトしました。\nログインし直してください。\n初めてログインされる方はそのままOKボタンをクリックしてください。',
  appVersion: '1.13.3 (993ca881)',
};

export default Config;
